// extracted by mini-css-extract-plugin
module.exports = {"graphic":"FAQPet_graphic_1HM9Z"};